import type { WorkflowStepType } from "@sagot/constants";
import type { IconName } from "@sagot/ui";

export const STEP_ICONS: Record<WorkflowStepType, IconName> = {
  send_webhook: "webhook",
  add_tags: "tag",
  remove_tags: "tag",
  assign: "user-check",
  set_status: "check-circle",
  add_note: "pencil",
  update_lead: "user-plus",
  notify_staff: "bell",
  branch: "git-branch",
  apply_rules: "filter",
  go_to_path: "arrow-right",
  end: "circle",
  send_message: "message-square",
  reply_buttons: "list-checks",
  collect_data: "pencil",
  let_assistant_answer: "sparkles",
  show_booking: "calendar",
  show_lead_form: "user-plus",
  hand_to_person: "headset",
  expected_reply_time: "clock",
  ask_rating: "star",
  wait: "clock",
  apply_sla: "gauge",
  set_priority: "arrow-up",
  email_visitor: "mail",
  set_attribute: "sliders-horizontal",
  run_workflow: "workflow",
  wait_for_webhook: "webhook",
  http_request: "plug",
  collect_reply: "message-circle",
  verify_email: "shield-check",
  disable_reply: "lock",
  enable_reply: "unlock",
  snooze: "pause",
  set_language: "languages",
  show_article: "book-open",
  add_summary_note: "file-text",
  notify_team: "bell",
  route_handoff: "git-branch",
  assign_lead_owner: "user-check",
  send_to_subscribed_endpoints: "webhook",
  // Service desk (M27)
  create_ticket: "plus",
  update_ticket: "pencil",
  set_ticket_state: "circle-dot",
  route_ticket: "split",
  assign_ticket: "user-plus",
  add_ticket_note: "sticky-note",
  reply_to_ticket: "reply",
  notify_contact: "mail",
  link_ticket: "link-2",
  apply_ticket_sla: "gauge",
  request_csat: "star",
  ticket_intake: "ticket",
  show_ticket_form: "list",
  show_my_tickets: "inbox",
  // After-sales (M27 S3) and orders (M27 S2)
  lookup_asset: "search",
  schedule_visit: "calendar",
  lookup_catalogue: "search",
  check_order_status: "package",
  show_catalogue: "list",
  create_order: "shopping-cart",
  show_order_status: "package",
};
